import { media } from 'styled-bootstrap-grid'
import styled, { css } from 'styled-components'
import { common } from '@ocean/ui'

const { Typography } = common

const baseHeaderStyles = css`
  display: block;
  text-align: center;
  line-height: 1.5;

  ${({ theme }) => `
    color: ${theme.color.white};
    margin-bottom: ${theme.space.mobile.large};
  `};

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.large};
  `};
`

export const Header = styled.div`
  ${baseHeaderStyles}
`

export const SpecialMessage = styled.div`
  ${baseHeaderStyles}
`

export const ErrorWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space.mobile.tiny};
`

export const Maintenance = styled.div`
  ${({ theme }) => `
    margin: ${theme.space.mobile.large} ${theme.space.mobile.small} 0;
  `}

  ${({ theme }) => media.sm`
    margin: ${theme.space.desktop.huge} ${theme.space.desktop.small} 0;
  `}
`

export const Footer = styled.div`
  display: block;
  text-align: center;
  line-height: 1.5;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.large};
  `};

  ${({ theme }) => media.sm`
    margin-top: ${theme.space.desktop.large};
  `};
`

export const SsoLoginButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  line-height: 1.5;
  text-transform: uppercase;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.small};
  `};

  ${({ theme }) => media.sm`
    margin-top: ${theme.space.desktop.small};
  `};
`

export const SsoLoginTypography = styled(Typography)`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.small};
  `};

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.small};
  `};
`
